// web/src/features/profile/hooks/useUpdateFamilyContact.ts
//
// PUT mutation for editing a family contact. Invalidates the player's family
// cache on success. Web port of the mobile hook.
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { familyScopeKey } from '@sportninja/common/services/player/familyScope'
import {
  updateFamilyContact,
  type UpdateFamilyContactInput,
  type UpdateFamilyContactResponse,
} from '@sportninja/common/services/player/updateFamilyContact'

export const useUpdateFamilyContact = () => {
  const queryClient = useQueryClient()
  return useMutation<
    UpdateFamilyContactResponse,
    Error,
    UpdateFamilyContactInput
  >({
    mutationFn: updateFamilyContact,
    // Override the global mutations.retry=1 default (see queryClient config).
    retry: 0,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.playerFamily.byPlayer(
          variables.playerId,
          familyScopeKey(variables.scope)
        ),
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.playerDetails.byId(variables.playerId),
      })
    },
  })
}
